import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CodeBlock = ({ code, language = 'javascript', label }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard?.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  const LANG_COLORS = {
    javascript: 'text-yellow-400',
    bash: 'text-green-400',
    python: 'text-blue-400',
    php: 'text-violet-400',
    html: 'text-orange-400',
    json: 'text-cyan-400',
  };

  return (
    <div className="rounded-lg overflow-hidden border border-border">
      {/* Code header */}
      <div className="flex items-center justify-between px-4 py-2.5 bg-[#161b22] border-b border-[#30363d]">
        <div className="flex items-center gap-2">
          <div className="flex gap-1.5">
            <div className="w-3 h-3 rounded-full bg-[#ff5f57]" />
            <div className="w-3 h-3 rounded-full bg-[#febc2e]" />
            <div className="w-3 h-3 rounded-full bg-[#28c840]" />
          </div>
          {label && (
            <span className={`text-xs font-mono font-medium ml-2 ${LANG_COLORS?.[language] || 'text-muted-foreground'}`}>
              {label}
            </span>
          )}
        </div>
        <button
          onClick={handleCopy}
          className="flex items-center gap-1.5 px-2.5 py-1 rounded text-xs text-[#8b949e] hover:text-[#e6edf3] hover:bg-white/10 transition-smooth"
        >
          <Icon name={copied ? 'Check' : 'Copy'} size={13} />
          <span>{copied ? 'Copied!' : 'Copy'}</span>
        </button>
      </div>
      {/* Code body */}
      <pre className="bg-[#0d1117] text-[#e6edf3] p-5 text-xs font-mono overflow-x-auto leading-relaxed">
        {code}
      </pre>
    </div>
  );
};

export default CodeBlock;
